import moment from 'moment';
import { Flex } from 'reflexbox';
import styled from 'styled-components';

import * as graphql from '@treams/treams-network';

import { tokens } from '@treams/treams-ui';

import { calendarEventDayKey } from '../../types/CalendarEvent';
import LearningCalendarDay from './LearningCalendarDay';

const LearningCalendarWeekElement = styled(Flex)`
	border-top: 1px solid ${tokens.border.subtle};
`;

const LearningCalendarWeek = ({
	year,
	month,
	week,
	eventsByDateString,
}: {
	year: number;
	month: number;
	week: number;
	eventsByDateString: Record<string, graphql.LearningEvent[]>;
}) => {
	const startOfWeek = moment(`${year}-${week}`, 'YYYY-WW').startOf('isoWeek').isoWeekday(0);

	return (
		<LearningCalendarWeekElement>
			{Array(7)
				.fill(null)
				.map((_, index) => {
					const date = startOfWeek
						.clone()
						.add(index + 1, 'days')
						.toDate();
					const events = eventsByDateString[calendarEventDayKey(date)];

					return (
						<LearningCalendarDay
							month={month}
							date={date}
							key={date.toISOString()}
							events={events ?? []}
						/>
					);
				})}
		</LearningCalendarWeekElement>
	);
};

export default LearningCalendarWeek;
